var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKitchenUtensil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2001_2476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6 3.91C10.6013 3.61763 10.5449 3.32787 10.4339 3.05737C10.3229 2.78687 10.1596 2.54096 9.95333 2.33375C9.74705 2.12655 9.50187 1.96213 9.23188 1.84994C8.96188 1.73775 8.67238 1.68 8.38 1.68H3.92C3.62763 1.68 3.33813 1.73775 3.06813 1.84994C2.79813 1.96213 2.55296 2.12655 2.34668 2.33375C2.1404 2.54096 1.97709 2.78687 1.86611 3.05737C1.75514 3.32787 1.69869 3.61763 1.7 3.91V8.54C1.69869 8.83238 1.75514 9.12213 1.86611 9.39263C1.97709 9.66313 2.1404 9.90904 2.34668 10.1162C2.55296 10.3235 2.79813 10.4879 3.06813 10.6001C3.33813 10.7123 3.62763 10.77 3.92 10.77H8.38C8.67238 10.77 8.96188 10.7123 9.23188 10.6001C9.50187 10.4879 9.74705 10.3235 9.95333 10.1162C10.1596 9.90904 10.3229 9.66313 10.4339 9.39263C10.5449 9.12213 10.6013 8.83238 10.6 8.54V3.91Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 17C8.00001 16.7613 7.90519 16.5324 7.7364 16.3636C7.56762 16.1948 7.3387 16.1 7.10001 16.1H5.25001C5.01131 16.1 4.78239 16.1948 4.61361 16.3636C4.44483 16.5324 4.35001 16.7613 4.35001 17V21.6C4.35001 21.8387 4.44483 22.0676 4.61361 22.2364C4.78239 22.4052 5.01131 22.5 5.25001 22.5H7.05001C7.2887 22.5 7.51762 22.4052 7.6864 22.2364C7.85519 22.0676 7.95001 21.8387 7.95001 21.6L8.00001 17Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14999 16.11V10.77",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.51999 4.54V7.92",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.78 4.54V7.92",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3 6.32C22.3297 5.66923 22.2271 5.01919 21.9985 4.40916C21.7699 3.79914 21.42 3.24178 20.97 2.77076C20.52 2.29975 19.9791 1.92485 19.3801 1.66871C18.7812 1.41257 18.1365 1.28051 17.485 1.28051C16.8336 1.28051 16.1889 1.41257 15.5899 1.66871C14.9909 1.92485 14.4501 2.29975 14 2.77076C13.55 3.24178 13.2001 3.79914 12.9715 4.40916C12.7429 5.01919 12.6403 5.66923 12.67 6.32V6.51C12.7265 7.74906 13.2585 8.91865 14.1553 9.77551C15.0521 10.6324 16.2447 11.1105 17.485 11.1105C18.7254 11.1105 19.918 10.6324 20.8148 9.77551C21.7116 8.91865 22.2435 7.74906 22.3 6.51V6.32Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.29 17.2C19.29 16.9613 19.1952 16.7324 19.0264 16.5636C18.8576 16.3948 18.6287 16.3 18.39 16.3H16.59C16.3513 16.3 16.1224 16.3948 15.9536 16.5636C15.7848 16.7324 15.69 16.9613 15.69 17.2V21.6C15.69 21.8387 15.7848 22.0676 15.9536 22.2364C16.1224 22.4052 16.3513 22.5 16.59 22.5H18.39C18.6287 22.5 18.8576 22.4052 19.0264 22.2364C19.1952 22.0676 19.29 21.8387 19.29 21.6V17.2Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.49 16.3V11.3",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2001_2476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchenUtensil);
export default __webpack_public_path__ + "static/media/Kitchen Utensil.5860a89f055feee5ac193e5bd7e105e9.svg";
export { ForwardRef as ReactComponent };